import StethoscopeIcon from '@mui/icons-material/MedicalServices';
import { CoronersList } from './CoronersList';
import { CoronersCreate } from './CoronersCreate';
import { CoronersEdit } from './CoronersEdit';

const coroners = {
  list: CoronersList,
  create: CoronersCreate,
  edit: CoronersEdit,
  icon: StethoscopeIcon,
};

export default coroners;
